import * as React from 'react';

var _path, _path2;

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function SvgDownload(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.98 20.894l6.532-6.531.707.707-7.739 7.739-7.738-7.74.708-.706 6.53 6.532V7.858h1v13.036zM9.071 23.032h1v1.96H24.89v-1.96h1v2.96H9.07v-2.96z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.41 2.68a15.5 15.5 0 10-11.864 28.64A15.5 15.5 0 0023.409 2.68zM14.258.817a16.5 16.5 0 116.438 32.366A16.5 16.5 0 0114.259.817z"
  })));
}

export { SvgDownload as default };